import type { EmailActivity } from '@common/types/activities';
import { Box, Link, Typography } from '@mui/material';
import ShowLessButton from '../ShowLessButton';

interface Props {
    emailBody: EmailActivity['body'];
    isBodyExpanded: boolean;
    setIsBodyExpanded: (val: boolean) => void;
}

export default function TreefortIdvCompletionMailToLawyerBody({
    emailBody,
    isBodyExpanded,
    setIsBodyExpanded,
}: Props) {
    return (
        <Box
            sx={{
                marginTop: '16px',
                wordWrap: 'break-word',
                overflowWrap: 'anywhere',
            }}
        >
            <Typography
                variant="h4"
                sx={{
                    marginBottom: '16px',
                }}
            >
                Identity Verification Successfully Completed
            </Typography>
            <Typography variant="body2" color="text.primary">
                {emailBody?.FirstName} has successfully completed the Identity verification process.
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.primary', marginTop: '16px' }}>
                You can review the verification report for the prospect{' '}
                <Link
                    href={emailBody?.ProspectLink}
                    sx={{ textDecoration: 'none', cursor: 'pointer' }}
                >
                    here{' '}
                </Link>
                or in the attachment.
            </Typography>
            <ShowLessButton
                isBodyExpanded={isBodyExpanded}
                bodyExpandedHandler={setIsBodyExpanded}
            />
        </Box>
    );
}
